import { createAction } from '@reduxjs/toolkit'
import { typePagination, typeRequestPagination } from '../system/constants';
import { IdRefundsStateDataItem, typeRefundsFilters } from 'model/dashboardRefunds/dRefundsReducer';

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data
export const dRefundsSetDataAC = createAction(
    'D_REFUNDS_SET_DATA',
    ( dataList: IdRefundsStateDataItem[] ) => ( { payload: { dataList } } )
)

// Action creator of saga set data
export const dRefundsSetDataSagaAC = createAction(
    'D_REFUNDS_SET_DATA_SAGA',
    (
        filters: typeRefundsFilters,
        paginationRequest: typeRequestPagination
    ) => ( { payload: { filters, paginationRequest } } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set item data
export const dRefundsSetDetailItemAC = createAction(
    'D_REFUNDS_SET_DETAIL_ITEM',
    ( detailItemId: string ) => ( { payload: detailItemId } )
)
// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set item data
export const dRefundSetDetailItemFromSalesAC = createAction(
    'D_REFUNDS_SET_DETAIL_ITEM_FROM_SALES',
    ( detailItem: any ) => ( { payload: detailItem } )
)
// ---------------------------------------------------------------------------------------------------------------------
// Action creator of clear filtersForm
export const dRefundsClearFiltersAC = createAction(
    'D_REFUNDS_CLEAR_FILTERS',
)

// Action creator of set filtersForm
export const dRefundsSetFiltersAC = createAction(
    'D_REFUNDS_SET_FILTERS',
    ( filtersObject: typeRefundsFilters ) => ( { payload: filtersObject } )
)

// Action creator of set filtersForm saga
export const dRefundsSetFiltersSagaAC = createAction(
    'D_REFUNDS_SET_FILTERS_SAGA',
    (
        filtersObject: typeRefundsFilters,
        paginationRequest: typeRequestPagination
    ) => ( {
        payload: {  filtersObject, paginationRequest }
    } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set pagination
export const dRefundsSetPaginationAC = createAction(
    'D_REFUNDS_SET_PAGINATION',
    (
        pagination: typePagination,
    ) => ( { payload: { pagination } } )
)

// Action creator of set itemsForPage in pagination
export const dRefundsSetItemsForPageAC = createAction(
    'D_REFUNDS_SET_ITEMS_FOR_PAGE',
    (
        itemsForPage: number,
    ) => ( { payload: { itemsForPage } } )
)


// Action creator of set pageNumber in pagination
export const dRefundsSetPageNumberAC = createAction(
    'D_REFUNDS_SET_PAGE_NUMBER',
    (
        pageNumber: number,
    ) => ( { payload: { pageNumber } } )
)
